import '../shared'
import './init'

console.info('Codaf successfully loaded.')
